export default __webpack_public_path__ + "static/media/crossroads12.84e78b5f.webp";